<template>
  <!-- Main Content -->
  <v-card class="mx-auto" height="100%" width="100%">
    <!-- Left Navigation -->
    <left-navigation
      ref="left-navigation"
      v-if="$vuetify.breakpoint.mdAndUp || navMenuOpen"
    ></left-navigation>

    <!-- Top App Bar -->
    <top-navigation ref="top-navigation"></top-navigation>

    <!-- Contents -->
    <v-main>
      <v-container class="fill-height pa-0" fluid>
        <v-row no-gutters class="layout-cols-row">
          <!-- Left rail -->
          <v-col
            md="3"
            class="layout-cols layout-nav"
            v-if="$vuetify.breakpoint.mdAndUp || navMenuOpen"
          >
            <call-left-navigation
              ref="call-left-navigation"
            ></call-left-navigation>
          </v-col>
          <!-- Center rail -->
          <v-col
            cols="12"
            md="9"
            class="layout-cols"
            v-if="$vuetify.breakpoint.mdAndUp || !navMenuOpen"
          >
            <call-center-rail ref="call-center-rail"></call-center-rail>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-card>
</template>

<script>
const TopNavigation = () =>
  import(
    /* webpackChunkName: "components-global-TopNavigation" */ `../components/global/TopNavigation.vue`
  );
const LeftNavigation = () =>
  import(
    /* webpackChunkName: "components-global-LeftNavigation" */ `../components/global/LeftNavigation.vue`
  );
const CallLeftNavigation = () =>
  import(
    /* webpackChunkName: "components-calls-CallLeftNavigation" */ `../components/calls/CallLeftNavigation.vue`
  );
const CallCenterRail = () =>
  import(
    /* webpackChunkName: "components-calls-CallCenterRail" */ `../components/calls/CallCenterRail.vue`
  );

export default {
  name: "Calls",
  refs: "Calls",
  components: {
    TopNavigation,
    LeftNavigation,
    CallLeftNavigation,
    CallCenterRail
  },
  data: function() {
    return {
      selectedCallNumber: null,
      settingsNavSelected: "call-uniq-cust"
    };
  },
  computed: {
    navMenuOpen() {
      return this.$root.$children[0].navMenuOpen;
    }
  },
  created() {},
  methods: {}
};
</script>

<style lang="stylus">
div.settings-card div.container {
  padding-left: 0;
  padding-right: 0;
}
</style>
